import { render, staticRenderFns } from "./TableCampaign.vue?vue&type=template&id=5f3b41af"
import script from "./TableCampaign.vue?vue&type=script&lang=js"
export * from "./TableCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports